import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'
import type { SelfDescribingJson } from '@snowplow/browser-tracker'
import { getLuxPlusMemberPriceApplies } from 'lib/userCart/multiCartSnapshotUtils'
import { countOccupants } from 'lib/offer/occupancyUtils'
import { getAccommodationV2ItemService } from 'lib/checkout/checkoutUtils'
import { checkoutAccommodationOfferView } from 'checkout/selectors/view/accommodation'
import { getPropertyRateCategoryAndProductId } from 'analytics/snowplow/helpers/itemCategorisation'
import sanitizeItemContextMetadata from './sanitizeItemContextMetadata'

// offerId, typeId and rateId match getPropertyRateItemContext so funnel events join to SPP rate impressions
function getAccommodationV2ItemContext(
  state: App.State,
  item: App.Checkout.AccommodationV2Item,
  isMultiCart?: boolean,
): SelfDescribingJson {
  const totals = checkoutAccommodationOfferView(state).data
    .flatMap((offerView): Array<App.Checkout.BaseItemView<App.Checkout.AnyItem, App.LoyaltyProductType | undefined>> => offerView.itemViews)
    .find(itemView => itemView.item.itemId === item.itemId)?.totals
  const nonMemberPrice = totals?.price || item.sellTotal
  const memberPrice = totals?.memberPrice || item.luxPlusTotal || nonMemberPrice
  const price = getLuxPlusMemberPriceApplies(state, isMultiCart) ? memberPrice : nonMemberPrice
  const { adults, children, infants, childrenAge } = countOccupants([item.occupancy])

  return comluxgroup.createItem_1_1_2({
    offerId: item.offerId,
    ...getPropertyRateCategoryAndProductId(getAccommodationV2ItemService(item, state.checkout.accommodationSessions) === 'reservation' ? 'lpc' : 'bedbank'),
    typeId: item.roomId,
    rateId: item.internalRateId,
    packageId: item.packageId,
    travelStart: item.checkIn,
    travelEnd: item.checkOut,
    duration: item.duration,
    price,
    propertyFees: totals?.otherFees?.propertyFees ?? item.propertyFees,
    numberOfAdults: adults,
    numberOfChildren: children,
    numberOfInfants: infants,
    childrenAges: childrenAge,
    reservationType: 'instant_booking',
    itemId: item.itemId,
    currency: item.currency,
    metadata: sanitizeItemContextMetadata({
      isMultiCart: isMultiCart ?? state.checkout.cart.isMultiCart,
      memberPrice,
      nonMemberPrice,
    }),
  })
}

export default getAccommodationV2ItemContext
